import { Container, Content } from "./styles";

const TermsOfService = () => {
  return (
    <Container>
      <Content
        src="Termos_de_Uso_Politica_BovPilot.pdf"
        type="application/pdf"
      />
    </Container>
  );
};

export default TermsOfService;
